export const articles = [
  {
    id: 'summer-variety-review',
    title: '暑期档综艺复盘：慢综艺回温，观众更爱真实关系',
    section: 'entertainment',
    summary:
      '今年暑期档一批慢节奏综艺意外翻红，节目组放下强设定，把镜头交给嘉宾的日常相处，反而让讨论度一路走高。',
    cover:
      'https://readdy.ai/api/search-image?query=Warm%20sunlit%20variety%20show%20studio%20lounge%20with%20soft%20cream%20sofa%20and%20potted%20plants%2C%20cozy%20editorial%20photography%2C%20gentle%20amber%20tones%2C%20clean%20minimal%20composition%2C%20high%20detail&width=1200&height=800&seq=gua-ent-01&orientation=landscape',
    coverAlt: '暖色调的慢综艺录制场景',
    author: '瓜田值班室',
    date: '2026-09-10',
    readTime: 6,
    tags: ['慢综艺', '暑期档', '综艺复盘'],
    hot: true,
    views: 42800,
    keyPoints: [
      '强设定退场，日常相处成为主要看点',
      '嘉宾之间的真实关系比任务设计更能留住观众',
      '慢节奏内容更适合边做事边看，回看率明显偏高',
    ],
    blocks: [
      {
        heading: '强设定退场之后',
        paragraphs: [
          '过去两年，竞演和闯关类综艺靠密集的任务推动节奏，剪辑快、冲突足。今年暑期档却出现了明显反转：几档以聊天、做饭、旅行为主的节目悄悄爬上了讨论榜。',
          '节目组不再给嘉宾派发复杂任务，而是把时间留给他们自己。有人整理院子，有人研究一道菜，镜头就那么待着。看似没什么内容，观众却觉得「终于能喘口气」。',
        ],
      },
      {
        heading: '真实关系为什么更好看',
        paragraphs: [
          '慢综艺的核心看点其实不是风景，而是人和人之间的微妙变化。谁先开口、谁接了话、谁在角落里默默收拾，这些细节比剧本化的冲突更难演，也更容易让观众代入。',
          '不少观众在评论区提到，自己会把某段对话反复看好几遍。这种「回看」行为正是慢综艺区别于竞演节目的地方，也是它能持续发酵的原因。',
        ],
      },
      {
        heading: '接下来的变数',
        paragraphs: [
          '慢综艺的难点在于，一旦被观众看出「刻意营造的松弛」，好感度会迅速回落。如何在真实与好看之间找平衡，会是制作团队下一阶段最需要回答的问题。',
        ],
      },
    ],
  },
  {
    id: 'costume-drama-craft',
    title: '古装剧扎堆上线，服化道内卷到哪一步了',
    section: 'entertainment',
    summary:
      '同一档期多部古装剧同台，观众的目光从剧情转向了服化道。一件衣服的纹样、一支发簪的形制，都成了新的讨论点。',
    cover:
      'https://readdy.ai/api/search-image?query=Elegant%20traditional%20Chinese%20costume%20detail%20on%20mannequin%20with%20embroidered%20fabric%20and%20hairpin%2C%20museum%20soft%20lighting%2C%20warm%20ivory%20background%2C%20editorial%20still%20life%2C%20high%20detail&width=1200&height=800&seq=gua-ent-02&orientation=landscape',
    coverAlt: '古装剧服装与发饰细节',
    author: '追剧小分队',
    date: '2026-09-08',
    readTime: 7,
    tags: ['古装剧', '服化道', '剧集观察'],
    hot: true,
    views: 35600,
    keyPoints: [
      '观众开始用细节眼光看古装剧，服化道被单独讨论',
      '纹样、形制考据成为二次创作素材',
      '过度堆砌反而会让画面失去呼吸感',
    ],
    blocks: [
      {
        heading: '从看剧情到看细节',
        paragraphs: [
          '以前追古装剧，大家关心的是男女主什么时候和好。现在弹幕里讨论最多的，往往是主角袖口的暗纹和腰间的配饰。观众的目光变细了，剧组也就不得不跟着精细。',
          '一部剧的造型团队通常要在开拍前几个月做资料整理，从壁画、瓷器到旧照片里找参考。这份功课做没做，懂行的观众一眼就能看出来。',
        ],
      },
      {
        heading: '内卷的两面',
        paragraphs: [
          '考据越细，观众越买账，这是好事。但也有剧组把预算全砸在服装上，忽略了镜头调度和光线，结果画面很满、很贵，却缺少留白。',
          '好看的古装剧，靠的是造型与叙事的配合，而不是把所有精致元素一次性铺满。',
        ],
      },
    ],
  },
  {
    id: 'music-festival-small-city',
    title: '音乐节回归小城：一场演出带火一条街',
    section: 'entertainment',
    summary:
      '越来越多音乐节选择在县城和近郊举办，交通、住宿和餐饮随之被带动，一场演出正在变成一座小城的周末大事。',
    cover:
      'https://readdy.ai/api/search-image?query=Outdoor%20music%20festival%20stage%20at%20dusk%20with%20warm%20string%20lights%20and%20crowd%20silhouettes%2C%20golden%20hour%20sky%2C%20small%20town%20background%2C%20editorial%20photography%2C%20warm%20tones&width=1200&height=800&seq=gua-ent-03&orientation=landscape',
    coverAlt: '小城傍晚的音乐节舞台',
    author: '现场观察员',
    date: '2026-09-05',
    readTime: 5,
    tags: ['音乐节', '小城经济', '现场演出'],
    hot: false,
    views: 21400,
    keyPoints: [
      '小城场地成本低，观众也更愿意过夜消费',
      '演出带动住宿、餐饮与本地交通',
      '配套服务能否跟上决定口碑',
    ],
    blocks: [
      {
        heading: '为什么是小城',
        paragraphs: [
          '一线城市的场地排期紧、成本高，小城则有闲置的体育场和郊野公园。对主办方来说，租金和搭建压力都更小；对观众来说，票更好抢，也更愿意顺便住一晚。',
          '于是周末的城市节奏被打乱：高铁到站的人流、街边排队的烧烤摊、临时增加的接驳车，构成了一种新的热闹。',
        ],
      },
      {
        heading: '热闹之外的考验',
        paragraphs: [
          '一场音乐节涌进来的人数，往往超过小城平时的接待能力。住宿临时涨价、末班车提前收车，都会迅速变成差评。能不能把一次性流量变成回头客，考验的是本地配套。',
        ],
      },
    ],
  },
  {
    id: 'night-school-trend',
    title: '夜校走红之后：年轻人的下班社交换了种方式',
    section: 'society',
    summary:
      '报名靠抢、课程常满，夜校从一个小众选择变成了都市青年的固定日程。它提供的不只是技能，还有一种低压的社交场景。',
    cover:
      'https://readdy.ai/api/search-image?query=Evening%20community%20classroom%20with%20warm%20lamps%2C%20adults%20attending%20a%20craft%20workshop%2C%20cozy%20paper%20and%20plants%20on%20desks%2C%20soft%20amber%20light%2C%20documentary%20editorial%20style&width=1200&height=800&seq=gua-soc-01&orientation=landscape',
    coverAlt: '夜晚的社区教室课堂',
    author: '城市切片',
    date: '2026-09-11',
    readTime: 6,
    tags: ['夜校', '都市生活', '兴趣社交'],
    hot: true,
    views: 39800,
    keyPoints: [
      '低价课程降低了尝试门槛',
      '固定时间地点天然形成社交场景',
      '从技能培训转向兴趣与陪伴',
    ],
    blocks: [
      {
        heading: '从「学点东西」到「见见人」',
        paragraphs: [
          '最初大家报夜校，图的是便宜又实用：摄影、书法、咖啡制作，一节课的价格比一杯手冲还低。真正上下来才发现，最吸引人的其实是那间教室的氛围。',
          '固定的时间、固定的座位、每周都能见到同一批人。对这种低压的社交关系，很多上班族表示「比饭局轻松多了」。',
        ],
      },
      {
        heading: '供给跟不上热情',
        paragraphs: [
          '课程名额有限，报名往往在几分钟内被抢空。一些机构开始尝试与企业合作，把教室搬进写字楼，但师资和场地的限制依然存在。',
          '夜校能不能长期办下去，关键在于有没有稳定、认真的老师，而不是一时的话题热度。',
        ],
      },
    ],
  },
  {
    id: 'community-canteen',
    title: '社区食堂火出圈，一顿饭背后的生活账',
    section: 'society',
    summary:
      '社区食堂不再只是老年餐桌，午休的上班族、放学的孩子都成了常客。一顿十几块的饭，折射的是城市生活的成本与便利。',
    cover:
      'https://readdy.ai/api/search-image?query=Bright%20community%20canteen%20with%20trays%20of%20simple%20home%20style%20dishes%20on%20wooden%20counters%2C%20warm%20daylight%2C%20clean%20modern%20interior%2C%20editorial%20food%20photography&width=1200&height=800&seq=gua-soc-02&orientation=landscape',
    coverAlt: '社区食堂的取餐台',
    author: '城市切片',
    date: '2026-09-09',
    readTime: 5,
    tags: ['社区食堂', '日常生活', '城市观察'],
    hot: false,
    views: 18700,
    keyPoints: [
      '客群从老年人扩展到上班族与学生',
      '平价与干净是核心口碑',
      '能否长期维持取决于运营效率',
    ],
    blocks: [
      {
        heading: '谁在吃社区食堂',
        paragraphs: [
          '中午十一点半，队伍里既有拎着菜篮的阿姨，也有刚下班的年轻人。十几块钱一荤两素，米饭管够，比外卖更快也更省。',
          '对独居的年轻人来说，食堂解决的不只是吃饭问题，还有「一个人也值得好好吃饭」的心理负担。',
        ],
      },
      {
        heading: '平价背后的难题',
        paragraphs: [
          '价格低靠的是薄利和稳定客流。一旦食材成本上涨、客流波动，运营压力会立刻显现。因此不少食堂开始靠早餐、外带和社区活动补充收入。',
        ],
      },
    ],
  },
  {
    id: 'park-picnic',
    title: '城市露营退潮，公园野餐成了新日常',
    section: 'society',
    summary:
      '装备堆满阳台的露营热退温后，一块野餐垫、一篮水果组成的新玩法开始流行。人们不再追求「仪式感拉满」，而是更看重随手可得的松弛。',
    cover:
      'https://readdy.ai/api/search-image?query=Weekend%20park%20picnic%20with%20checkered%20blanket%2C%20basket%20of%20fruit%20and%20flowers%2C%20green%20lawn%20and%20soft%20afternoon%20sun%2C%20gentle%20warm%20tones%2C%20lifestyle%20editorial%20photography&width=1200&height=800&seq=gua-soc-03&orientation=landscape',
    coverAlt: '公园里的野餐场景',
    author: '周末放空组',
    date: '2026-09-06',
    readTime: 4,
    tags: ['野餐', '城市露营', '周末生活'],
    hot: false,
    views: 15200,
    keyPoints: [
      '重装备露营热度回落，轻量野餐接棒',
      '核心诉求从「打卡」转向「放松」',
      '公园配套成为体验关键',
    ],
    blocks: [
      {
        heading: '从搬家式露营到一块垫子',
        paragraphs: [
          '前几年露营讲究装备齐全，天幕、折叠椅、露营灯一样不能少。如今阳台上的装备渐渐吃灰，一块垫子加一篮水果就能出发。',
          '门槛降下来之后，参与的人反而更多。不用提前规划营地，也不用担心收摊到半夜，出门就是周末。',
        ],
      },
      {
        heading: '公园需要配套',
        paragraphs: [
          '野餐人群增多，垃圾处理和公共座椅的压力也随之上升。一些公园开始增加分类垃圾桶和临时洗手点，让这股风潮能更从容地持续下去。',
        ],
      },
    ],
  },
  {
    id: 'folding-phone-light',
    title: '折叠屏进入轻量时代，铰链和重量成新战场',
    section: 'tech',
    summary:
      '新一代折叠屏把重点从「能不能折」转向「折起来好不好用」。重量、折痕和铰链寿命，成了发布会必讲的三个关键词。',
    cover:
      'https://readdy.ai/api/search-image?query=Sleek%20foldable%20smartphone%20laid%20open%20on%20a%20warm%20minimal%20desk%20with%20soft%20studio%20lighting%2C%20brushed%20metal%20finish%2C%20editorial%20product%20photography%2C%20clean%20beige%20background&width=1200&height=800&seq=gua-tec-01&orientation=landscape',
    coverAlt: '展开的折叠屏手机特写',
    author: '数码风向标',
    date: '2026-09-12',
    readTime: 6,
    tags: ['折叠屏', '数码新品', '手机'],
    hot: true,
    views: 44100,
    keyPoints: [
      '重量下探到接近直板旗舰',
      '铰链结构与折痕控制成为核心卖点',
      '软件分屏体验决定折叠屏的实际价值',
    ],
    blocks: [
      {
        heading: '先解决手感',
        paragraphs: [
          '早期折叠屏最大的抱怨是「像揣了两台手机」。这一代产品把重量压了下来，合起来握持接近普通旗舰，放进口袋也不再鼓包。',
          '重量每少一点，都意味着铰链材料、屏幕基板和中框结构的重新设计。厂商愿意在这上面较劲，说明折叠屏已经进入拼手感的阶段。',
        ],
      },
      {
        heading: '折痕与耐用',
        paragraphs: [
          '折痕无法完全消失，但可以做得更浅。铰链的悬停角度和开合阻尼，直接决定了日常使用中是否顺手。',
          '另一个被反复提及的指标是开合寿命。数字好看与否，最终还是要交给时间和真实用户去验证。',
        ],
      },
      {
        heading: '软件才是分水岭',
        paragraphs: [
          '硬件趋同之后，差距会出现在软件上。能不能把大屏用起来，比如真正的多任务分屏、应用自适应布局，才是折叠屏区别于直板手机的地方。',
        ],
      },
    ],
  },
  {
    id: 'on-device-ai',
    title: 'AI 助手进手机：本地大模型能干什么',
    section: 'tech',
    summary:
      '把模型搬到手机上，不再是什么都往云端送。离线总结、通话摘要、相册搜索，这些功能正在悄悄改变日常使用习惯。',
    cover:
      'https://readdy.ai/api/search-image?query=Smartphone%20held%20in%20hand%20showing%20abstract%20warm%20amber%20data%20visualization%2C%20minimal%20desk%20setting%2C%20soft%20studio%20lighting%2C%20editorial%20tech%20photography&width=1200&height=800&seq=gua-tec-02&orientation=landscape',
    coverAlt: '手机端本地 AI 功能示意',
    author: '数码风向标',
    date: '2026-09-07',
    readTime: 6,
    tags: ['端侧AI', '大模型', '智能手机'],
    hot: false,
    views: 27600,
    keyPoints: [
      '本地运行更省流量，也更能保护隐私',
      '擅长短文本任务，复杂推理仍需云端',
      '功耗与发热是端侧落地的关键限制',
    ],
    blocks: [
      {
        heading: '把计算留在本地',
        paragraphs: [
          '端侧模型的最大好处是响应快、数据不出设备。整理一段会议录音、给相册自动分类，这些操作在离线状态下也能完成。',
          '对于在意隐私的用户来说，这一点比参数量更有说服力。',
        ],
      },
      {
        heading: '它能做什么，不能做什么',
        paragraphs: [
          '本地模型擅长总结、改写、提取要点这类短任务。一旦涉及长逻辑推理或最新知识，还是得交给云端。',
          '因此现阶段更合理的形态是「端云协同」：轻活本地干，重活交给服务器。',
        ],
      },
      {
        heading: '功耗的隐形天花板',
        paragraphs: [
          '模型跑在手机上，电量和发热是最现实的门槛。厂商通常会把端侧功能限制在特定场景，避免长时间高负载运行。',
        ],
      },
    ],
  },
  {
    id: 'smart-home-remote',
    title: '智能家居的下一步，是把「遥控器」藏起来',
    section: 'tech',
    summary:
      '设备越来越多，遥控器和 App 也越堆越乱。行业开始尝试用场景和语音替代逐个操作，让智能家居真正回到「无感」的体验。',
    cover:
      'https://readdy.ai/api/search-image?query=Cozy%20modern%20living%20room%20with%20warm%20ambient%20lighting%20and%20minimal%20smart%20home%20devices%2C%20wood%20and%20linen%20textures%2C%20soft%20evening%20light%2C%20editorial%20interior%20photography&width=1200&height=800&seq=gua-tec-03&orientation=landscape',
    coverAlt: '温馨的智能家居客厅',
    author: '居家实验室',
    date: '2026-09-03',
    readTime: 5,
    tags: ['智能家居', '物联网', '生活方式'],
    hot: false,
    views: 12900,
    keyPoints: [
      '设备数量增长带来操作负担',
      '场景联动与语音替代逐个遥控',
      '生态互通仍是最大痛点',
    ],
    blocks: [
      {
        heading: '遥控器越来越多',
        paragraphs: [
          '灯、窗帘、空调、音箱各自一个 App，用户被切成了好几块。真正的智能不应该是掏出手机点五下，而是一句「我回来了」全部就位。',
          '于是「场景」成了新的组织方式：回家、观影、睡眠，每个场景预设一组设备状态，操作从多个动作收敛成一个。',
        ],
      },
      {
        heading: '互通才是难点',
        paragraphs: [
          '不同品牌之间的协议壁垒，让跨生态联动变得麻烦。行业标准在推进，但落地速度仍取决于各家意愿。',
        ],
      },
    ],
  },
  {
    id: 'league-youth',
    title: '联赛开启年轻化：00 后球员挑大梁',
    section: 'sports',
    summary:
      '新赛季多支球队把首发位置交给了年轻球员，跑动更多、节奏更快。年轻化不只是口号，也在改变比赛的实际打法。',
    cover:
      'https://readdy.ai/api/search-image?query=Young%20athletes%20training%20on%20an%20outdoor%20track%20at%20golden%20hour%2C%20motion%20and%20determination%2C%20warm%20sunlight%2C%20editorial%20sports%20photography%2C%20clean%20background&width=1200&height=800&seq=gua-spo-01&orientation=landscape',
    coverAlt: '傍晚训练场上的年轻球员',
    author: '看台记者',
    date: '2026-09-10',
    readTime: 5,
    tags: ['联赛', '年轻球员', '赛事观察'],
    hot: false,
    views: 20300,
    keyPoints: [
      '首发阵容平均年龄明显下降',
      '高强度跑动带来更快的比赛节奏',
      '经验与稳定性成为年轻球队的新课题',
    ],
    blocks: [
      {
        heading: '阵容年轻化',
        paragraphs: [
          '新赛季多支队伍的首发名单里，二十岁出头的球员占了半数以上。教练组更愿意给年轻人机会，也更敢于在关键场次派他们上场。',
          '这种变化的直接结果，是比赛的跑动数据整体上升。攻防转换更快，留给对手思考的时间更短。',
        ],
      },
      {
        heading: '快，也要稳',
        paragraphs: [
          '年轻带来活力，也带来起伏。领先之后如何控场、落后时如何调整心态，是这批球员必须补上的一课。',
        ],
      },
    ],
  },
  {
    id: 'marathon-signup',
    title: '马拉松报名费为何越来越难抢',
    section: 'sports',
    summary:
      '热门城市的马拉松名额一放出来就被抢空，中签率走低。跑步人群的扩张，正在重新定义一场城市赛事的分量。',
    cover:
      'https://readdy.ai/api/search-image?query=Marathon%20runners%20crossing%20a%20city%20bridge%20at%20sunrise%2C%20soft%20warm%20light%2C%20motion%20blur%2C%20editorial%20sports%20photography%2C%20clean%20morning%20tones&width=1200&height=800&seq=gua-spo-02&orientation=landscape',
    coverAlt: '清晨城市桥上的马拉松跑者',
    author: '看台记者',
    date: '2026-09-04',
    readTime: 5,
    tags: ['马拉松', '路跑', '城市赛事'],
    hot: false,
    views: 16800,
    keyPoints: [
      '跑步人群扩大，热门赛事中签率下降',
      '赛事成为城市形象的展示窗口',
      '补给与医疗保障是口碑基础',
    ],
    blocks: [
      {
        heading: '一场城市级的热闹',
        paragraphs: [
          '马拉松早已不只是一场比赛。封路、志愿者、沿途表演和补给站，把一条赛道变成城市整天的公共活动。',
          '对跑者来说，中签是一种运气；对城市来说，办得好就是一次集中展示。',
        ],
      },
      {
        heading: '体验决定复购',
        paragraphs: [
          '补给是否充足、医疗点是否到位、领物是否顺畅，这些细节会直接写在跑者的赛后记录里。口碑好的赛事，第二年会更难抢。',
        ],
      },
    ],
  },
  {
    id: 'city-cycling',
    title: '城市骑行热：一条绿道带动的周末经济',
    section: 'sports',
    summary:
      '周末的滨江绿道上，骑行队伍排成长龙。自行车租赁、沿途咖啡和维修点，围绕一条绿道长出了新的小生意。',
    cover:
      'https://readdy.ai/api/search-image?query=Cyclists%20riding%20along%20a%20greenway%20by%20the%20river%20in%20soft%20morning%20light%2C%20warm%20golden%20tones%2C%20peaceful%20urban%20scenery%2C%20editorial%20lifestyle%20photography&width=1200&height=800&seq=gua-spo-03&orientation=landscape',
    coverAlt: '江边绿道上的骑行队伍',
    author: '周末放空组',
    date: '2026-09-02',
    readTime: 4,
    tags: ['骑行', '绿道', '周末经济'],
    hot: false,
    views: 14100,
    keyPoints: [
      '绿道成为周末运动与社交场地',
      '围绕骑行衍生出租、维修、补给生意',
      '基础设施与安全提示仍需完善',
    ],
    blocks: [
      {
        heading: '骑行成了周末默认选项',
        paragraphs: [
          '比起健身房，骑行有风景、有同伴，也能顺路吃顿早饭。滨江和郊野绿道的周末人流，近几年持续上升。',
          '沿线的小店顺势调整：咖啡提前开门，便利店增加冰饮，自行车维修摊也多了起来。',
        ],
      },
      {
        heading: '热闹需要秩序',
        paragraphs: [
          '骑行人群和散步人群共用一条道，速度差与礼让规则就成了安全隐患。清晰的标识和分区，是这条绿道能长久热闹下去的前提。',
        ],
      },
    ],
  },
  {
    id: 'slow-live-commerce',
    title: '直播电商转向「慢直播」：卖货也讲内容',
    section: 'influencer',
    summary:
      '叫卖式的直播渐渐让人疲惫，一批主播开始用讲解、探访、实测的节奏带货。内容留住人，成交反而更自然。',
    cover:
      'https://readdy.ai/api/search-image?query=Content%20creator%20hosting%20a%20calm%20live%20stream%20in%20a%20warm%20home%20studio%2C%20ring%20light%20and%20plants%2C%20cozy%20beige%20interior%2C%20editorial%20lifestyle%20photography&width=1200&height=800&seq=gua-inf-01&orientation=landscape',
    coverAlt: '居家氛围的慢直播场景',
    author: '流量观察',
    date: '2026-09-11',
    readTime: 6,
    tags: ['直播电商', '内容创作', '慢直播'],
    hot: true,
    views: 37200,
    keyPoints: [
      '从叫卖转向讲解与实测',
      '内容质量决定停留时长与转化',
      '对主播专业能力要求更高',
    ],
    blocks: [
      {
        heading: '叫卖的疲劳感',
        paragraphs: [
          '重复的话术和倒计时，短期内有效，却很难让观众留下来。看多了之后，用户会本能地划走。',
          '于是「慢直播」出现了：主播花十分钟讲一件产品的来龙去脉，中间穿插使用演示，成交在讲述里自然发生。',
        ],
      },
      {
        heading: '内容即货架',
        paragraphs: [
          '这种模式把直播间变成了小型内容栏目。观众未必当场下单，但会记住这个主播，复购率反而更稳。',
          '代价是对主播的要求更高，需要对产品足够了解，也要有把复杂事情讲清楚的能力。',
        ],
      },
    ],
  },
  {
    id: 'knowledge-creators',
    title: '知识博主内卷：三分钟讲清一件事的边界',
    section: 'influencer',
    summary:
      '知识类内容越来越密集，「三分钟讲透」成了标配标题。但当信息被压缩到极致，观众也开始追问：这真的讲清楚了吗。',
    cover:
      'https://readdy.ai/api/search-image?query=Creator%20recording%20an%20explainer%20video%20at%20a%20desk%20with%20notebooks%20and%20a%20camera%2C%20warm%20desk%20lamp%20light%2C%20minimal%20beige%20study%20room%2C%20editorial%20photography&width=1200&height=800&seq=gua-inf-02&orientation=landscape',
    coverAlt: '桌前的知识类视频录制',
    author: '流量观察',
    date: '2026-09-08',
    readTime: 5,
    tags: ['知识博主', '短视频', '内容生态'],
    hot: false,
    views: 19900,
    keyPoints: [
      '短时长与高信息密度的矛盾',
      '可视化与类比是常见解法',
      '过度简化容易造成误解',
    ],
    blocks: [
      {
        heading: '把复杂压进三分钟',
        paragraphs: [
          '知识类内容的核心竞争力是「讲明白」。为了适配短视频节奏，博主们大量使用动画、类比和生活化案例。',
          '这确实降低了很多领域的入门门槛，但也带来了新的问题。',
        ],
      },
      {
        heading: '简化的代价',
        paragraphs: [
          '当一件事被压缩到只剩结论，观众很容易记住观点、忽略条件。真正负责的博主会在结尾提醒适用范围，而不是给一个万能的说法。',
        ],
      },
    ],
  },
  {
    id: 'rural-creators',
    title: '乡村博主崛起，镜头里的家乡成了新流量',
    section: 'influencer',
    summary:
      '越来越多创作者把镜头对准家乡的田野和灶台，朴实的生活内容反而获得了跨地域的关注，也带火了当地的农产品。',
    cover:
      'https://readdy.ai/api/search-image?query=Rural%20countryside%20farmhouse%20kitchen%20with%20fresh%20vegetables%20and%20warm%20sunlight%2C%20wooden%20table%2C%20cozy%20earth%20tones%2C%20documentary%20editorial%20photography&width=1200&height=800&seq=gua-inf-03&orientation=landscape',
    coverAlt: '乡村厨房里的新鲜蔬果',
    author: '流量观察',
    date: '2026-09-01',
    readTime: 5,
    tags: ['乡村博主', '助农', '内容创作'],
    hot: false,
    views: 17600,
    keyPoints: [
      '生活化内容获得跨地域关注',
      '内容带火当地农产品与短途游',
      '可持续依赖内容真实度',
    ],
    blocks: [
      {
        heading: '朴实的镜头更有说服力',
        paragraphs: [
          '没有复杂运镜，只有柴火灶、刚摘的蔬菜和院子里的猫。这类内容意外地稳定，因为观众能从中看到一种具体的、可触摸的生活。',
        ],
      },
      {
        heading: '流量落地到家乡',
        paragraphs: [
          '关注度累积之后，博主往往会把话题引向当地的特产和小众景点。内容与助农、短途游结合，形成了新的合作方式。',
          '但这份信任建立在真实之上。一旦过度包装，观众会很快察觉。',
        ],
      },
    ],
  },
];